/* eslint-disable react/no-danger,jsx-a11y/iframe-has-title */
import React from 'react';
import PropTypes from 'prop-types';
import {filterHTML} from "../../helpers/filters";
import './VideoCard.scss';

const VideoCard = ({fieldTxtHeadline, fieldTxtSubTitle, fieldHtmlBody, fieldVarVideoLink}) => (
    <div className="videoCard">
        {fieldVarVideoLink && fieldVarVideoLink.url && fieldVarVideoLink.url.path && (
            <div className="videoCard__video">
                <iframe src={fieldVarVideoLink.url.path} width="100%" height="300" frameBorder="0" allowFullScreen/>
            </div>
        )}

        <div className="videoCard__text">

            {fieldTxtHeadline && (
                <h3 className="videoCard__title">
                    {fieldTxtHeadline}
                </h3>
            )}

            {fieldTxtSubTitle && (
                <p className="videoCard__subtitle">
                    {fieldTxtSubTitle}
                </p>
            )}

            {fieldHtmlBody && fieldHtmlBody.processed && (
                <p className="videoCard__body">
                    <div dangerouslySetInnerHTML={{__html: filterHTML(fieldHtmlBody.processed)}}/>
                </p>
            )}

        </div>

    </div>
);

VideoCard.propTypes = {
    fieldTxtHeadline: PropTypes.string,
    fieldTxtSubTitle: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    fieldHtmlBody: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    fieldVarVideoLink: PropTypes.object.isRequired
};

VideoCard.defaultProps = {
    fieldTxtHeadline: '',
    fieldTxtSubTitle: '',
    fieldHtmlBody: {}
};

export default VideoCard;



// WEBPACK FOOTER //
// ./frontend/components/VideoCards/VideoCard.jsx